import http from "../http-rda";

class DataService {
  getAll(params) {
    return http.get("/topics-students-logs", { params });
  }

  getCounts(params) {
    return http.get("/topics-students-logs/counts", { params });
  }

  getMonthlyCounts(params) {
    return http.get("/topics-students-logs/monthly-counts", { params });
  }

  getStatistics(params) {
    return http.get("/topics-students-logs/statistics", { params });
  }
}

export default new DataService();
